import React, { useState, useContext } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import ConfirmationModal from "../ConfirmationModal";
import { Menu } from "@material-ui/core";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import toastError from "../../errors/toastError";

const MessageOptionsMenu = ({ message, menuOpen, handleClose, anchorEl }) => {
  const { setReplyingMessage } = useContext(ReplyMessageContext);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDeleteMessage = async () => {
    setDeleting(true);

    try {
      await api.delete(`/messages/${message.id}`);
      toast.success(i18n.t("messageOptionsMenu.deleteSuccess"));
      setConfirmationOpen(false);
    } catch (err) {
      toastError(err);
    } finally {
      setDeleting(false);
    }
  };

  const handleReplyMessage = () => {
    setReplyingMessage(message);
    handleClose();
  };

  const handleOpenConfirmationModal = (e) => {
    setConfirmationOpen(true);
    handleClose();
  };
  
  const handleCopyMessage = () => {
    if (message.body) {
      navigator.clipboard.writeText(message.body)
        .then(() => {
          toast.success("Mensaje copiado al portapapeles");
        })
        .catch(() => {
          toast.error("Error al copiar el mensaje");
        });
    }
    handleClose();
  };

  return (
    <>
      <ConfirmationModal
        title={i18n.t("messageOptionsMenu.confirmationModal.title")}
        open={confirmationOpen}
        onClose={setConfirmationOpen}
        onConfirm={handleDeleteMessage}
        closeOnConfirm={false}
        confirming={deleting}
      >
        {i18n.t("messageOptionsMenu.confirmationModal.message")}
      </ConfirmationModal>
      <Menu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={menuOpen}
        onClose={handleClose}
      >
        {message.fromMe && !message.isDeleted && (
          <MenuItem onClick={handleOpenConfirmationModal}>
            {i18n.t("messageOptionsMenu.delete")}
          </MenuItem>
        )}
        <MenuItem onClick={handleReplyMessage}>
          {i18n.t("messageOptionsMenu.reply")}
        </MenuItem>        
        <MenuItem onClick={handleCopyMessage}>
          Copiar
        </MenuItem>
      </Menu>
    </>
  );
};

export default MessageOptionsMenu;
